import { PassAlertFailControlConfigItem } from "../config/pass-alert-fail-control-config-item.model";
import { PassAlertFailFieldItemValue } from "./pass-alert-fail-control-item-value.model";
import { PassAlertFailFieldNodeFormProvider } from "./pass-alert-fail-control-node-value-provider.interface";
import { FormControl } from "@angular/forms";

export class PassAlertFailFieldNode implements PassAlertFailControlConfigItem {
    id: string;
    type: string;
    title: string;
    key: string;
    children: Array<PassAlertFailFieldNode>;

    constructor(
        option: PassAlertFailControlConfigItem,
        protected formProvider: PassAlertFailFieldNodeFormProvider
    ) {
        Object.keys(option).forEach(key => this[key] = option[key]);
        this.children = option.children.map(child => new PassAlertFailFieldNode(child, formProvider));
    }

    getFormControl(): FormControl {
        return this.formProvider.getFormControl(this);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/pass-alert-fail/form/pass-alert-fail-control-node.model.ts